<template>
  <div class="exam-events-list">
    <div
      v-for="event in orderedEvents"
      :key="event.status"
      class="exam-events-list-item"
    >
      <div
        class="exam-events-list-item-circle"
        :style="{
          backgroundColor: traceabilityStatusColors[event.status]
        }"
      />

      <div class="exam-events-list-item-event">
        {{ traceabilityStatusLabels[event.status] }}
      </div>

      <div class="exam-events-list-item-date">
        {{ event.date | date }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'

import { traceabilityStatusLabels, traceabilityStatusColors } from '@/constants';

export default {
  name: 'ExamEventsList',
  filters: {
    date(date) {
      return moment(date).format('DD/MM/YYYY [às] HH:mm')
    }
  },
  props: {
    events: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      traceabilityStatusLabels,
      traceabilityStatusColors
    }
  },
  computed: {
    orderedEvents() {
      return [...this.events].sort((a, b) => moment(b.date).diff(moment(a.date)));
    }
  }
}
</script>

<style lang="scss" scoped>
.exam-events-list {
  font-family: 'Exo 2';
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  &-item {
    display: flex;
    align-items: center;
    gap: 1.625rem;
    height: 1.25rem;

    &-circle {
      width: 0.75rem;
      height: 0.75rem;
      border-radius: 50%;
      position: relative;

      &::before {
        content: '';
        height: 2.125rem;
        width: 1px;
        background-color: #CCCCCC;
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    &:last-child &-circle::before {
      display: none;
    }

    &-event {
      flex: 1;
      font-weight: 600;
      font-size: 0.875rem;
      color: #363636;
    }

    &-date {
      font-weight: 400;
      font-size: 0.875rem;
      color: #595959;
    }
  }
}
</style>
